import React from "react";
import { HiOutlineMail, HiOutlinePhone, HiOutlineLocationMarker } from "react-icons/hi";
import Reveal, { staggerContainer, staggerItem } from "./Reveal";
import SectionHeading from "./SectionHeading";
import { motion } from "framer-motion";
import { personal } from "../data/content";
import { useLanguage } from "../context/LanguageContext";

export default function About() {
    const { t } = useLanguage();

    const facts = [
        { icon: HiOutlineMail, label: t.about.facts.email, value: personal.email, href: `mailto:${personal.email}` },
        { icon: HiOutlinePhone, label: t.about.facts.phone, value: personal.phone, href: `tel:${personal.phone}` },
        { icon: HiOutlineLocationMarker, label: t.about.facts.location, value: t.about.location },
    ];

    return (
        <section id="about" className="section">
            <div className="section__inner">
                <SectionHeading eyebrow={t.about.eyebrow} title={t.about.title} />

                <div className="about__grid">
                    <Reveal className="about__bio" delay={0.05}>
                        <p>{t.hero.summary}</p>

                        <motion.div
                            className="about__facts"
                            variants={staggerContainer}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, amount: 0.3 }}
                        >
                            {facts.map((fact) => {
                                const Icon = fact.icon;
                                const Tag = fact.href ? "a" : "div";
                                return (
                                    <motion.div key={fact.label} variants={staggerItem} className="fact-card">
                                        <Tag href={fact.href} className="fact-card__inner">
                                            <span className="fact-card__icon">
                                                <Icon />
                                            </span>
                                            <span>
                                                <span className="fact-card__label">{fact.label}</span>
                                                <span className="fact-card__value">{fact.value}</span>
                                            </span>
                                        </Tag>
                                    </motion.div>
                                );
                            })}
                        </motion.div>
                    </Reveal>

                    <Reveal className="about__languages" delay={0.15}>
                        <h3 className="about__languages-title">{t.about.languagesTitle}</h3>
                        {t.languages.map((lang, i) => (
                            <div className="lang-bar" key={lang.name}>
                                <div className="lang-bar__row">
                                    <span className="lang-bar__name">{lang.name}</span>
                                    <span className="lang-bar__level">{lang.level}</span>
                                </div>
                                <div className="lang-bar__track">
                                    <motion.div
                                        className="lang-bar__fill"
                                        initial={{ width: 0 }}
                                        whileInView={{ width: `${lang.value}%` }}
                                        viewport={{ once: true, amount: 0.6 }}
                                        transition={{ duration: 1, delay: 0.1 * i, ease: [0.22, 0.9, 0.32, 1] }}
                                    />
                                </div>
                            </div>
                        ))}
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
